// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionCss_a1yvges3{margin-top:8px;}
.keyboardShortcutCss_k8kanek{color:var(--gray40a);margin:4px 0;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/tooltip/DescriptionTooltip.css"],"names":[],"mappings":"AAAA,oBAAoB,cAAc,CAAC;AACnC,6BAA6B,oBAAoB,CAAC,YAAY,CAAC","sourcesContent":[".actionCss_a1yvges3{margin-top:8px;}\n.keyboardShortcutCss_k8kanek{color:var(--gray40a);margin:4px 0;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
